import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_slsodr_to_slsinv_consol_run_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  run_hdr_guid: fromDatatype.GuidDataFieldInterface;
  slsodr_hdr_guid: fromDatatype.GuidDataFieldInterface;
  slsodr_line_guid: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  branch_code: fromDatatype.VarcharDatatypeInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  location_code: fromDatatype.VarcharDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  location_code_2: fromDatatype.VarcharDatatypeInterface;
  slsodr_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  slsodr_salesman_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  consol_slsinv_hdr_guid: fromDatatype.GuidDataFieldInterface;
  consol_slsinv_line_guid: fromDatatype.GuidDataFieldInterface;
  processor_posting_status: fromDatatype.VarcharDatatypeInterface;
  processor_posting_error: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  total_slsodr_line_count: fromDatatype.IntegerDatatypeInterface;
  generic_doc_link_guid: fromDatatype.GuidDataFieldInterface;
  consol_slsinv_group_guid: fromDatatype.GuidDataFieldInterface;
  consolidated_date: fromDatatype.TimestampTzDatatypeInterface;
  total_slsinv_line_count: fromDatatype.IntegerDatatypeInterface;
}

export class bl_fi_slsodr_to_slsinv_consol_run_line_RowClass
  implements bl_fi_slsodr_to_slsinv_consol_run_line_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  run_hdr_guid: fromDatatype.GuidDataFieldInterface;
  slsodr_hdr_guid: fromDatatype.GuidDataFieldInterface;
  slsodr_line_guid: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  branch_code: fromDatatype.VarcharDatatypeInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  location_code: fromDatatype.VarcharDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  location_code_2: fromDatatype.VarcharDatatypeInterface;
  slsodr_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  slsodr_salesman_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  consol_slsinv_hdr_guid: fromDatatype.GuidDataFieldInterface;
  consol_slsinv_line_guid: fromDatatype.GuidDataFieldInterface;
  processor_posting_status: fromDatatype.VarcharDatatypeInterface;
  processor_posting_error: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  total_slsodr_line_count: fromDatatype.IntegerDatatypeInterface;
  generic_doc_link_guid: fromDatatype.GuidDataFieldInterface;
  consol_slsinv_group_guid: fromDatatype.GuidDataFieldInterface;
  consolidated_date: fromDatatype.TimestampTzDatatypeInterface;
  total_slsinv_line_count: fromDatatype.IntegerDatatypeInterface;
}
